import gql from 'graphql-tag';

export class ConversationMutations {
  static addMessage = gql`
    mutation AddMessage($payload: AddMessageInput!) {
      addMessage(payload: $payload) {
        id
        createdAt
        updatedAt
        text
        owner {
          participantId: recipientId
          userId
        }
        reads {
          timestamp
          participant {
            participantId: recipientId
            userId
          }
        }
        metadata {
          editorComment {
            editorBlockId
            sectionId
            rowId
            cellId
            nodeId
          }
          videoId
          attachmentId
          imageId
          repliedTo
          mentions {
            participantId: recipientId
            userId
          }
        }
      }
    }
  `;

  static setMessageReadBy = gql`
    mutation SetMessageReadBy($payload: MessageReadByInput!) {
      setMessageReadBy(payload: $payload)
    }
  `;

  static deleteMessage = gql`
    mutation DeleteMessage($payload: DeleteMessageInput!) {
      deleteMessage(payload: $payload)
    }
  `;

  static typingStatus = gql`
    mutation TypingStatus($conversationId: String!, $isTyping: Boolean!) {
      typingStatus(conversationId: $conversationId, isTyping: $isTyping)
    }
  `;

  static createConversation = gql`
    mutation CreateConversation($payload: CreateConversationInput!) {
      createConversation(payload: $payload) {
        id
        title
        type
        owner {
          participantId: recipientId
          userId
        }
        participants {
          participantId: recipientId
          userId
        }
      }
    }
  `;
}
